import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RenewPasswordActions } from '../actions';
import { from, of } from 'rxjs';
import { map, catchError, switchMap, withLatestFrom } from 'rxjs/operators';
import { Base64 } from '@app/shared/helpers/base64';
import { Store, select } from '@ngrx/store';
import * as fromSignin from '../reducers';
import { errors, Directory } from '@smash-sdk/directory/ejs/11-2023';
import { isInThePast } from 'smash-time';


@Injectable()
export class RenewPasswordEffects {
    renewPassword$ = createEffect(() =>
        this.actions$.pipe(
            ofType(RenewPasswordActions.renewPassword),
            withLatestFrom(this.store$.pipe(select(fromSignin.getRenewPasswordToken))),
            switchMap(([action, decodedMessage]: any[]) => {
                const directorySdk = new Directory();
                return from(directorySdk.resetPassword({ password: action.password, ...decodedMessage })).pipe(
                    map((response) => {
                        return RenewPasswordActions.renewPasswordSuccess();
                    }),
                    catchError((error: any) => {
                        if (error instanceof errors.ResetPasswordError.ExpiredSecretError
                            || error instanceof errors.ResetPasswordError.InvalidSecretError
                        ) {
                            return of(RenewPasswordActions.renewTokenExpired({ error: error.message }));
                        } else {
                            return of(RenewPasswordActions.renewPasswordFailure({ error: error.message }));
                        }
                    })
                )
            }
            )
        )
    );

    decodeMessage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(RenewPasswordActions.decodeMessage),
            switchMap((action) => {
                try {
                    const base64 = new Base64();
                    const decodedMessage = base64.decode(action.message);
                    const decodedMessageToObject = JSON.parse(decodedMessage);
                    if (isInThePast(decodedMessageToObject.expiry)) {
                        return of(RenewPasswordActions.renewTokenExpired({ error: 'Token expired' }));
                    }
                    return of(RenewPasswordActions.decodeMessageSuccess({ decodedTokenMessage: JSON.parse(decodedMessage) }));
                } catch (error) {
                    return of(RenewPasswordActions.decodeMessageFailure({ error: error.message }));
                }

            })
        )
    );

    constructor(
        private actions$: Actions,
        private store$: Store<fromSignin.State>,
    ) { }

}
